import { MerchantKycStatuses } from 'services/merchants/types';

export const hasKycStarted = (kycStatus?: MerchantKycStatuses): boolean => {
  return Boolean(kycStatus) && kycStatus !== MerchantKycStatuses.NotStarted;
};
